import { Outlet } from "react-router-dom";

// project imports

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
  <>
    <Outlet />
    {/* {process.env.REACT_APP_ENV === Environment.DEV && <Customization />} */}
  </>
);

export default MinimalLayout;
